/**
 * presentationPreviewStore — зеркало настроек презентаций для превью-слайда.
 *
 * Виджет на /bots/tools/slides живёт в СОБСТВЕННОМ GenerateProvider
 * (изоляция widget-режима, см. App.tsx), а «образ слайда» рендерится в теле
 * страницы — в другом дереве контекста. useGenerate() там вернул бы App-level
 * провайдер со стейлом из localStorage без живых обновлений.
 *
 * Паттерн проекта — внешний мини-канал (как api/studioFolderTracker):
 * каждый GenerateProvider публикует свои presentation-настройки эффектом,
 * подписчики читают через useSyncExternalStore. Последний публикующий
 * побеждает — на странице слайдов это виджет (изменения происходят в нём).
 */
import { useSyncExternalStore } from 'react'
import type { PresentationSettings } from '../hooks/useGenerateSettings'

let current: PresentationSettings | null = null
const listeners = new Set<() => void>()

export function publishPresentationSettings(p: PresentationSettings | undefined) {
	current = p ?? null
	listeners.forEach((l) => l())
}

function subscribe(cb: () => void) {
	listeners.add(cb)
	return () => {
		listeners.delete(cb)
	}
}

const getSnapshot = () => current

export function usePresentationSettingsMirror(): PresentationSettings | null {
	return useSyncExternalStore(subscribe, getSnapshot)
}
